import React, {Component} from "react";
import {Card, CardBody, Progress,Col,Row} from "reactstrap";




class DeviceOffline extends Component {
    render() {

        return (
            <div className="animated fadeIn">
                <Row>
                    <Col xs="12" lg="12">
                        <Card className="text-white bg-danger text-center">
                            <CardBody className="card-body">
                                <blockquote className="card-bodyquote">
                                        <i className="fa fa-plug fa-lg mt-4"></i><br/>
                                        <p>Device is offline...</p>
                                </blockquote>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default DeviceOffline;


// WEBPACK FOOTER //
// ./src/views/site/DeviceMessages/DeviceOffline.js